// Chakra imports
import { Flex, Image, Text } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
   return (
    <><Flex alignItems="center" flexDirection="column">
      <Image src={window.config.logo} w="150px" mb="20px" />
    </Flex>
    <Flex alignItems="flex-end" flexDirection="column">
        <Text fontSize={"smaller"} mr={"30px"} color={"navy.300"} mt={"-16px"} fontFamily={"sans-serif"} fontWeight={"bold"}>
          v{localStorage.getItem("_version")}
        </Text>
        <HSeparator mb="20px" />
      </Flex></>
  );
}

export default SidebarBrand;
